export type BaseFieldColorScheme = 'white' | 'blue';
export const DEFAULT_BASE_FIELD_COLOR_SCHEME: BaseFieldColorScheme = 'blue';
